import { useEffect, useState } from "react"
import {
  getVideoUrlMetadata,
  type VideoUrlMetadata,
} from "~/common/media/uploadedResources"

type MetadataResult = {
  url: string
  metadata?: VideoUrlMetadata
  failed?: boolean
}

// 随视频地址读取时长和宽高；地址变化时自动丢弃过期结果
export const useVideoUrlMetadata = (videoUrl: string) => {
  const url = videoUrl.trim()
  const [result, setResult] = useState<MetadataResult>({ url: "" })

  useEffect(() => {
    if (!url) return

    let ignored = false

    void getVideoUrlMetadata(url)
      .then((metadata) => {
        if (ignored) return
        const valid =
          Number.isFinite(metadata.duration) && metadata.duration > 0
        setResult(valid ? { url, metadata } : { url, failed: true })
      })
      .catch(() => {
        if (!ignored) setResult({ url, failed: true })
      })

    return () => {
      ignored = true
    }
  }, [url])

  const current = result.url === url ? result : undefined

  return {
    metadata: current?.metadata,
    loading: Boolean(url) && !current,
    failed: Boolean(current?.failed),
  }
}
